import React, { useState, useEffect, useRef } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useNavigate } from "react-router-dom";

//Assets
import assetInput_bg from "../../assets/assetInput_bg.svg";
import copy_icon from "../../assets/icons/copy_small.svg";

//Components
import WalletInfoCopy from "../WalletInfoCopy";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { MOBILE } from "../../constants/breakpoints";

function ConfirmModal({
  assetWalletAddress,
  storageWalletAddress,
  handleContinueBtn,
  toggleDropDown,
}: {
  assetWalletAddress: string;
  storageWalletAddress: string;
  handleContinueBtn: any;
  toggleDropDown: any;
}) {
  const dispatch = useDispatch();

  const elementRef = useRef<HTMLDivElement>(null);

  let wallet = useSelector((state: RootState) => state.walletState);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        elementRef.current &&
        !elementRef.current.contains(event.target as Node)
      ) {
        toggleDropDown();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [toggleDropDown]);

  const navigate = useNavigate();

  return (
    <section
      id="wc_bg"
      css={css`
        display: flex;
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(27, 31, 36, 0.74);
        z-index: 1000;
        justify-content: center;
        align-items: center;
      `}
    >
      <div
        ref={elementRef}
        css={css`
          display: flex;
          flex-direction: column;
          width: 582px;
          height: max-content;
          background-color: white;
          padding: 64px;
          box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07),
            0px 64.8148px 46.8519px rgba(0, 0, 0, 0.0531481),
            0px 38.5185px 25.4815px rgba(0, 0, 0, 0.0425185),
            0px 20px 13px rgba(0, 0, 0, 0.035),
            0px 8.14815px 6.51852px rgba(0, 0, 0, 0.0274815),
            0px 1.85185px 3.14815px rgba(0, 0, 0, 0.0168519);
          border-radius: 24px;
          align-items: center;
          background: url(${assetInput_bg});
          background-repeat: no-repeat;
          background-size: contain;
          background-color: white;

          @media (max-width: ${MOBILE}px) {
            width: 90%;
            padding: 48px 18px;
          }
        `}
      >
        <h1
          css={css`
            text-align: center;
            margin: 0;
            font-weight: 700;
            font-size: 24px;
            line-height: 150%;

            @media (max-width: ${MOBILE}px) {
              font-size: 16px;
            }
          `}
        >
          Are you sure you want to use these Asset wallet and Storage wallet
          IDs?
        </h1>
        <span
          css={css`
            display: flex;
            flex-direction: column;
            margin-top: 48px;
            gap: 16px;
            @media (max-width: ${MOBILE}px) {
              width: 100%;
            }
          `}
        >
          {/* TODO Fix this */}
          <WalletInfoCopy
            label_text="Asset Wallet"
            value={assetWalletAddress}
          />
          <WalletInfoCopy
            label_text="Storage Wallet"
            value={storageWalletAddress}
          />
        </span>

        <button
          css={css`
            background: #ffd550;
            border-radius: 12px;
            width: 100%;
            height: 47.5px;
            border: none;
            font-weight: 800;
            font-size: 16px;
            line-height: 22px;
            margin-top: 47px;
            cursor: pointer;
            transition: all 0.1s ease-in-out;
            &:hover {
              scale: 1.05;
            }
          `}
          onClick={() => {
            handleContinueBtn();
          }}
        >
          Continue
        </button>
      </div>
    </section>
  );
}

export default ConfirmModal;
